<template>
    <div id="game" :class="['futura']">
        <template v-if="screentype =='bottom'">
            <div class="bull-bottom">
                <div class="numpad">
                    <numpad :game_id="game.id" ref="numpad"></numpad>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="game2022 bull">
                <div class="bull-left">
                    <viewer :stream_ids="JSON.stringify(player1boardcam)" :auth_user_id="logged_in_user" v-if="player1boardcam && webcamdata.length > 0"/>
                </div>
                <div class="bull-right">
                    <viewer :stream_ids="JSON.stringify(player2boardcam)" :auth_user_id="logged_in_user" v-if="player2boardcam && webcamdata.length > 0"/>
                </div>
                <div class="bull-bottom">
                    <div class="numpad">
                        <numpad :game_id="game.id" ref="numpad"></numpad>
                    </div>
                </div>
                <div class="game-players">
                    <game-asset-v-3-score-player v-for="player, idx in players" :playerIndex="idx" :playerId="player.player_id" :key="idx"></game-asset-v-3-score-player>
                </div>
            </div>
        </template>
        <game-asset-v-3-stuck-dart></game-asset-v-3-stuck-dart>
        <b-modal id="modal-leg-end" :title="__('games.bull_end')" @hidden="startGame">
            <template #default>
                <div class="results">
                    {{bullWinnerName}}<br/>{{__('games.has_won_bull')}}.
                </div>
            </template>
            <template #modal-footer>
                <b-button
                    variant="success"
                    size="lg"
                    class="float-right ml-2 modal-button"
                    @click="startGame"
                    v-html="__('games.start_game')">
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import numpad from "./gameAssets/gameAssetNumpadV2.vue";
import GameAssetScorePlayer from "./gameAssets/gameAssetScorePlayer.vue";
import GameAssetGameHistory from "./gameAssets/gameAssetGameHistory.vue";
import GameAssetDetermineStartPlayer from "./gameAssets/gameAssetDetermineStartPlayer.vue";
import GameAssetVideoPlayer from "./gameAssets/gameAssetVideoPlayer.vue";
import GameAssetStatistics from "./gameAssets/gameAssetStatisticsSmall.vue";
import GameAssetGameResults from "./gameAssets/gameAssetGameResults.vue";

import GameManagerV2 from "./gameAssets/gameManagerV2";
import moment from "moment";

//new
import GameAssetScoresSmall from "./gameAssets/gameAssetScoresSmall.vue";
import GameManager from "./gameAssets/gameManager";
import GameAssetV2ScorePlayer from "./gameAssets/gameAssetV2ScorePlayer.vue";
import CpuOpponent from "./CpuOpponent";

export default {
	components: {
		numpad,
		GameAssetScorePlayer,
		GameAssetGameHistory,
		GameAssetDetermineStartPlayer,
		GameAssetVideoPlayer,
		GameAssetStatistics,
		GameAssetGameResults,
		GameAssetScoresSmall,
		GameAssetV2ScorePlayer,
	},
	props: ["game_prop", "players_prop", "logged_in_user", "logged_in_player", "webcamdata"],
	mixins: [],
	data() {
		return {
			game: this.game_prop,
			disabledInput: false,
			numpadTempScore: "",
			players: null,
			sendInputTimer: null,
			currentPlayer: false,
			layoutProfile: null,
			showmenu: "numpad",
            winnerFound: false,
            bullWinnerName: '',
            game_id: undefined,
            player1boardcam: null,
            player2boardcam: null,
		};
	},
	created() {
		// create game manager object and read options
		this.gm = new GameManagerV2(this.game, this);
		window.logged_in_user = this.logged_in_user;
        this.screentype = window.name;
        console.log(this.webcamdata);
        this.webcamdata.forEach(camdata => {
            if (camdata.name == "Spieler 1 Boardkamera") this.player1boardcam = [camdata];
            if (camdata.name == "Spieler 2 Boardkamera") this.player2boardcam = [camdata];
        });
	},
	mounted() {
		this.layoutProfile = window.currentProfile
			? window.currentProfile
			: { layout: 1, show_history: true, show_numpad: true };
		if (!this.layoutProfile.show_numpad && this.layoutProfile.show_history) this.showmenu = "history";

		window.connection.subscribe(this);
		this.update(window.connection.lastUpdate);
	},
	methods: {
		update(data) {
			if (data == null) return;
			//update players from gamestate
			if (this.players == null) {
				this.players = data.players;
			}

			//check if current player is the player in the browser
			this.currentPlayer = data.gameState.currentPlayer == this.logged_in_player || data.gameState.currentUser == this.logged_in_user;

            this.game_id = data.gameState.game_id;

			if (data.action == "endOfGame") {
                let idx = 0;
                this.players.forEach(player => {
                    idx += 1;
                    if (player.player_id == data.gameState.winner) {
                        this.bullWinnerName = player.player.name ? player.player.name : player.player.guestname ? player.player.guestname : "Spieler " + idx;
                    }
                });
				this.winnerFound = true;
                this.$bvModal.show('modal-leg-end');
			}
		},
		showSubMenu(name) {
			this.showmenu = name;
		},
        startGame() {
            if (this.game_id)
                axios.post("/games/join", {game: this.game_id});
        }
	},
};
</script>

<style scoped>
    .bull-left {
        grid-area: bull-left;
    }
    .bull-bottom {
        grid-area: bull-bottom;
        display: flex;
        align-self: center;
        justify-self: center;
    }
    .bull-right {
        grid-area: bull-right;
    }
    #modal-leg-end .results {
        font-size: 3vw;
        justify-content: center;
    }
    .modal-button {
        font-size: 2vw;
        margin-top: 1vw;
    }
    .modal-footer {
        display: none !important;
    }
</style>
